<template>
  <v-app :style="{ background: $vuetify.theme.themes[theme].background }">
    <v-content>
      <router-view v-if="isIdle"></router-view>
    </v-content>
    <movable :posTop="posTOP" :posLeft="posLEFT" :diabled="wantToPin">
      <process-manager-upload
        v-if="activateShowUpload"
      ></process-manager-upload>
    </movable>
  </v-app>
</template>

<script>
import { mapState } from "vuex";

import processManagerUpload from "./components/processManagerUpload.vue";

import VueScreenSize from "vue-screen-size";

export default {
  name: "app",

  components: {
    processManagerUpload,
  },

  mixins: [VueScreenSize.VueScreenSizeMixin],

  data: function () {
    return {
      // activateShowUpload: false,
      posTOP: "",
      posLEFT: "",
      wantToPin: false,
    };
  },

  computed: {
    isIdle() {
      return "./";
    },
    theme() {
      return this.$vuetify.theme.dark ? "dark" : "light";
    },
    ...mapState(["augmentableTheme"]),

    ...mapState(["activateShowUpload"]),
  },

  mounted() {
    this.posTOP = "" + this.$vssHeight - 100;
    this.posLEFT = "" + this.$vssWidth - 300;
    this.$vuetify.theme.dark = this.augmentableTheme;
  },
};
</script>

<style lang="scss">
@import url("https://fonts.googleapis.com/css?family=Raleway:200,300,400,600,700,800,900");
@import url("https://fonts.googleapis.com/css?family=Nunito Sans:200,300,400,600,700,800,900");

#app {
  font-family: "Nunito Sans", "Raleway" !important;
  will-change: auto !important;
}
</style>


